enum ResidencyUses {
	None = 0,
	Household = 1,
	Business = 2,
	Service = 3
}

export default ResidencyUses;
